import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ChevronDown, Copy, XCircle } from "lucide-react";
import { toast } from "sonner";
import type { FailureInfo, RunLogRow } from "./types";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  failure?: FailureInfo;
  log?: RunLogRow;
}

const FailureDetails = ({ open, onOpenChange, failure, log }: Props) => {
  const payload = failure?.raw ?? log;
  return (
    <Collapsible open={open} onOpenChange={onOpenChange}>
      <CollapsibleTrigger asChild>
        <button
          type="button"
          className="w-full flex items-center justify-between px-3 py-1.5 text-[11px] text-destructive hover:bg-destructive/5 border border-destructive/30 rounded-md transition-colors"
        >
          <span className="flex items-center gap-1.5">
            <XCircle size={11} />
            {open ? "Hide failure details" : "View raw response / details"}
          </span>
          <ChevronDown size={11} className={`transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="border border-destructive/30 rounded-md bg-destructive/5 p-2 mt-1 space-y-2">
          {failure?.message && (
            <div>
              <p className="text-[10px] font-medium text-destructive uppercase tracking-wide mb-0.5">Error message</p>
              <p className="text-[11px] text-foreground break-words">{failure.message}</p>
            </div>
          )}
          <div>
            <div className="flex items-center justify-between mb-0.5">
              <p className="text-[10px] font-medium text-destructive uppercase tracking-wide">
                Raw {failure ? "response" : "log entry"}
              </p>
              <button
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(JSON.stringify(payload, null, 2));
                  toast.success("Copied to clipboard");
                }}
                className="text-[10px] text-muted-foreground hover:text-foreground flex items-center gap-1"
              >
                <Copy size={10} /> Copy
              </button>
            </div>
            <pre className="text-[10px] font-mono bg-background border border-border rounded p-2 max-h-48 overflow-auto whitespace-pre-wrap break-words">
{JSON.stringify(payload, null, 2)}
            </pre>
          </div>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default FailureDetails;
